import React from "react";
import { Button, FormControl, Nav } from "react-bootstrap"
import CurrencyInput from "react-currency-input";
import { createICMSTemplate, updateICMSTemplate } from "../../../../../api/products";
import { decimalFormat } from "../../../../../utils";
import * as DATA from "../data"
import AppContext from "../../../../AppViews/context";
import Text from "../../../../../_components/Text";
import LoadingInput from "../../../../../_components/LoadingInput";

/* 
    Portal SIMPLES NACIONAL
    http://www8.receita.fazenda.gov.br/SimplesNacional/Default.aspx
    Acessado em: terça-feira 13/12/2022

    * Simples Nacional não tem permissão de Crédito

    101, 102 e 103 - Operações sem substituição tributária 

        *101*:
            - Produto sem ST
            - Tributado no simples pelo ICMS
            - Destinatário tem direito ao crédito se ele for NORMAL, ou mercadoria destinada à industrialização ou revenda
            - Gera crédito ao adquirente
        *102*:
            - Consumidor final ou Optante pelo Simples Nacional
            - Destinatário não tem crédito
            - Não revenda nem industrialização
        *103*:
            - Quando a operação é de venda
            - A isenção do ICMS é de critério da UF
    
    201, 202 e 203 - Operações com substituição tributária (Tributadas pelo Simples Nacional)

    300 e 400 - Operações Não tributados pelo ICMS na apuração do SIMPLES

    *300*:
        - Receita com imunidade constituicional
        - Venda de livros, revistar, jornal, exportação
    
    *400*:
        - Tudo que não for receita:
            - Remessa para concerto
            - Remessa para industrialização
            - Remessa para demonstração
            - Doação
            - Bonificação
            - Demais saídas tributadas pelo ICMS

    900 - Retorno e devolução

LOGICA CSOSN:

    101:               SN
    102,103, 300, 400: Sem campos extras
    201, 203:          ST e SN (Sem retido)
    202:               ST (Sem retido)
    500:               ST Retido
    900:               TUDO (Menos ST Retido)

    *SN: Simples Nacional
    *ST: Substituicão Tributaria
    
*/

export const cst = [
    {
        value: "00",
        label: "Tributada integralmente"
    },
    {
        value: "10",
        label: "Tributada e com cobrança do ICMS por substituição tributária"
    },
    {
        value: "20",
        label: "Com redução de base de cálculo"
    },
    {
        value: "30",
        label: "Isenta ou não tributada e com cobrança do ICMS por substituição tributária"
    },
    {
        value: "40",
        label: "Isenta"
    },
    {
        value: "41",
        label: "Não tributada"
    },
    {
        value: "50",
        label: "Suspensão"
    },
    {
        value: "51",
        label: "Diferimento"
    },
    {
        value: "60",
        label: "ICMS cobrado anteriormente por substituição tributária"
    },
    {
        value: "70",
        label: "Com redução de base de cálculo e cobrança do ICMS por substituição tributária"
    },
    {
        value: "90",
        label: "Outros"
    }
]
export const csosn = []

export default class TemplateICMS extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: true,
            activeTab: "",
            data: { orig: "0", cst: "90" },
            loading: false,
            disabledTabICMS: true,
            disabledTabSN: true,
            disabledTabST: true,
            disabledSTRet: true,
        }
        this.handleTabNavigator = this.handleTabNavigator.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeSelect = this.handleChangeSelect.bind(this)
        this.onSave = this.onSave.bind(this)
    }
    handleChangeSelect(e) {
        const { name: key, value } = e.target
        const { data } = this.state
        data[key] = value

        console.debug(key, value)

        if (key === "csosn") {
            this.handleDisabledTab(data)
        }
        this.setState({ ...this, data })

    }
    handleChange(stringValue, doubleValue, e) {
        const { name: key, value } = e.target
        const { data } = this.state

        data[key] = doubleValue

        if (["p_icms", "bc_icms"].includes(key)) {
            const { p_icms, bc_icms } = data
            const bc = parseFloat(bc_icms || 0)
            const aliq = parseFloat(p_icms || 0) / 100
            const v_icms = decimalFormat((bc * aliq), 2)
            data["v_icms"] = v_icms
        }
        if (["p_icms_st", "v_bc_st"].includes(key)) {
            let { p_icms_st, v_bc_st } = data
            p_icms_st = parseFloat(p_icms_st || 0) / 100
        }
        this.setState({ ...this, data })
    }
    handleTabNavigator(e) {
        const { dataset } = e.target
        this.setState({ ...this, activeTab: dataset.rbEventKey })
    }
    handleClickTab(tabId) {
        setTimeout(() => {
            document.querySelector(`[data-rb-event-key="#${tabId}"]`).click()
        }, 100)
    }
    handleDisabledTab(data) {
        const { csosn } = data
        if (csosn === "101") {
            this.setState({
                ...this,
                activeTab: "",
                disabledTabICMS: true,
                disabledTabSN: false,
                disabledTabST: true,
                disabledSTRet: true,
            })
            this.hideTab("icms")
            this.hideTab("st")
            this.hideTab("ret")
            this.showTab("sn")

            this.handleClickTab("sn")
        } else if (["102", "103", "300", "400"].includes(csosn)) {
            this.setState({
                ...this,
                activeTab: "",
                disabledTabICMS: true,
                disabledTabSN: true,
                disabledTabST: true,
                disabledSTRet: true,
            })
            this.hideTab("icms")
            this.hideTab("sn")
            this.hideTab("st")
            this.hideTab("ret")
        } else if (["201", "203"].includes(csosn)) {
            this.setState({
                ...this,
                activeTab: "",
                disabledTabICMS: true,
                disabledTabSN: false,
                disabledTabST: false,
                disabledSTRet: true,
            })
            this.hideTab("icms")
            this.hideTab("ret")
            this.showTab("sn")
            this.showTab("st")
            this.handleClickTab("sn")
        } else if (csosn === "202") {
            this.setState({
                ...this,
                activeTab: "",
                disabledTabICMS: true,
                disabledTabSN: true,
                disabledTabST: false,
                disabledSTRet: true,
            })
            this.hideTab("icms")
            this.hideTab("sn")
            this.showTab("st")
            this.hideTab("ret")
            this.handleClickTab("st")
        } else if (csosn === "500") {
            this.setState({
                ...this,
                activeTab: "",
                disabledTabICMS: true,
                disabledTabSN: true,
                disabledTabST: true,
                disabledSTRet: false,
            })
            this.hideTab("icms")
            this.hideTab("sn")
            this.hideTab("st")
            this.showTab("ret")
            this.handleClickTab("ret")
        } else if (csosn === "900") {
            this.setState({
                ...this,
                activeTab: "",
                disabledTabICMS: false,
                disabledTabSN: false,
                disabledTabST: false,
                disabledSTRet: true,
            })
            this.hideTab("ret")
            this.showTab("icms")
            this.showTab("sn")
            this.showTab("st")
            this.handleClickTab("icms")
        }
    }
    hideTab(tab) {
        document.getElementById(`active-tab-${tab}`).classList.add("d-none")
    }
    showTab(tab) {
        document.getElementById(`active-tab-${tab}`).classList.remove("d-none")
    }
    async onSave() {
        this.setState({ ...this, loading: true })
        if (this.state.data["id"]) {
            await updateICMSTemplate(this.state.data)
                .then(newTemplate => {
                    newTemplate.v_icms = this.state.data.v_icms || 0
                    if (this.props.onSave) {
                        this.props.onSave(newTemplate)
                    }
                })
                .catch()
        } else {
            await createICMSTemplate(this.state.data)
                .then(newTemplate => {
                    if (this.props.onSave) {
                        this.props.onSave(newTemplate)
                    }
                })
                .catch()
        }
        this.setState({ ...this, loading: false })
    }
    componentDidMount() {
        if (this.props.data) {
            this.setState({ ...this, data: this.props.data })
            setTimeout(() => {
                this.handleDisabledTab(this.props.data)
            }, 1000)
        }
    }

    automate() {
        setTimeout(() => { this.handleChangeSelect({ target: { name: "name", value: "SIMPLES NACIONAL" } }) }, 150)
        setTimeout(() => { this.handleChangeSelect({ target: { name: "orig", value: 0 } }) }, 150)
        setTimeout(() => { this.handleChangeSelect({ target: { name: "csosn", value: "102" } }) }, 150)
        // setTimeout(() => this.onSave(), 350)
    }

    render() {
        const allowButtonSave = this.state.data["name"] && this.state.data["orig"] && this.state.data["csosn"] || this.state.data["id"]
        return <AppContext>
            {
                context => {
                    const { currentBranch } = context

                    if (currentBranch.crt === 1) {
                        return <div>
                        <div className={`${!this.props.create? 'd-none':''}`} >

                            <Text>Importante: esse tipo de configuração padrão deve ser consultado e confirmado, de preferência, pela contabilidade da sua empresa.</Text>
                            <span onClick={this.automate.bind(this)} style={{ cursor: "pointer" }} className="text-success">clique aqui para criar o modelo mais comum (padrão)</span>
                        </div>
                            <div className="form-group">
                                <div className="form-label">
                                    Nome:
                                </div>
                                <FormControl
                                    autoFocus={true}
                                    value={this.state.data["name"]}
                                    name="name"
                                    onChange={this.handleChangeSelect}
                                    disabled={this.state.loading}
                                />
                            </div>
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        Origem da Mercadoria
                                    </Text>
                                </div>
                                <FormControl
                                    name="orig"
                                    disabled={this.state.loading}
                                    onChange={this.handleChangeSelect}
                                    as="select">
                                    <option
                                        disabled
                                        selected>
                                        Selecione a origem
                                    </option>
                                    <option
                                        selected={this.state.data["orig"] === 0}
                                        value="0">
                                        0=Nacional
                                    </option>
                                    <option
                                        selected={this.state.data["orig"] === 1}
                                        value="1">
                                        0=Estrangeira (Importação direta)
                                    </option>
                                </FormControl>
                            </div>
                            <div className="form-group">
                                <div className="form-label">
                                    CSOSN
                                </div>
                                <div className="smal">
                                    Código de Situação da Operação no Simples Nacional
                                </div>
                                <FormControl
                                    name="csosn"
                                    onChange={this.handleChangeSelect}
                                    disabled={this.state.loading}
                                    as="select">
                                    <option
                                        disabled
                                        selected
                                        value="">Selecione o CSOSN</option>
                                    {
                                        DATA.CSOSN_DATA.map((item, idx) => {
                                            return <option
                                                selected={this.state.data["csosn"] === item.value}
                                                value={item.value}>{item.label}</option>
                                        })
                                    }
                                </FormControl>
                            </div>
                            <div className="py-3">
                                <Nav
                                    variant="pills"
                                    justify >
                                    <Nav.Item
                                        className="d-none"
                                        id="active-tab-icms"
                                        activeKey="#icms"
                                        onClick={this.handleTabNavigator}>
                                        <Nav.Link href="#icms" disabled={this.state.disabledTabICMS}>
                                            ICMS
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item
                                        className="d-none"
                                        id="active-tab-sn"
                                        activeKey="#sn"
                                        onClick={this.handleTabNavigator}>
                                        <Nav.Link eventKey="#sn" disabled={this.state.disabledTabSN}>
                                            SN
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item
                                        className="d-none"
                                        id="active-tab-st"
                                        activeKey="#st"
                                        onClick={this.handleTabNavigator}>
                                        <Nav.Link eventKey="#st" disabled={this.state.disabledTabST}>
                                            ST
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item
                                        className="d-none"
                                        id="active-tab-ret"
                                        activeKey="#ret" onClick={this.handleTabNavigator}>
                                        <Nav.Link eventKey="#ret" disabled={this.state.disabledSTRet}>
                                            ST Retido
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                            <div
                                className={this.state.activeTab === "#icms" ? "py-3" : "d-none"} >
                                <RenderInputs

                                    onChange={this.handleChange}
                                    handleChangeSelect={this.handleChangeSelect}
                                    loading={this.state.loading}
                                    data={this.state.data}
                                    items={DATA.ICMS_DATA_GROUP.ICMS}
                                />
                            </div>
                            <div
                                className={this.state.activeTab === "#sn" ? "py-3" : "d-none"} >
                                <RenderInputs
                                    onChange={this.handleChange}
                                    loading={this.state.loading}
                                    data={this.state.data}
                                    items={DATA.ICMS_DATA_GROUP.SN}
                                />
                            </div>
                            <div
                                className={this.state.activeTab === "#st" ? "py-3" : "d-none"} >
                                <RenderInputs
                                    handleChangeSelect={this.handleChangeSelect}
                                    onChange={this.handleChange}
                                    loading={this.state.loading}
                                    data={this.state.data}
                                    items={DATA.ICMS_DATA_GROUP.ST}
                                />
                            </div>
                            <div
                                className={this.state.activeTab === "#ret" ? "py-3" : "d-none"} >
                                <RenderInputs
                                    loading={this.state.loading}
                                    onChange={this.handleChange}
                                    data={this.state.data}
                                    items={DATA.ICMS_DATA_GROUP.RET}
                                />
                            </div>
                            <div className="d-flex justify-content-end">
                                <Button
                                    disabled={!allowButtonSave || this.state.loading}
                                    onClick={this.onSave} >
                                    Salvar ICMS
                                </Button>
                            </div>
                        </div>
                    } else {
                        return <div className="container">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="form-label">
                                            <Text>
                                                Descrição
                                            </Text>
                                        </div>
                                        <LoadingInput
                                            value={this.state.data.name}
                                            onChange={this.handleChangeSelect}
                                            name="name" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="form-label">
                                            <Text>
                                                Origem da Mercadoria
                                            </Text>
                                        </div>
                                        <FormControl
                                            name="orig"
                                            disabled={this.state.loading}
                                            onChange={this.handleChangeSelect}
                                            as="select">
                                            <option
                                                disabled
                                                selected
                                                value="">Selecione a origem</option>
                                            <option selected={this.state.data["orig"] === '0'} value="0">0=Nacional</option>
                                            <option selected={this.state.data["orig"] === '1'} value="1">0=Estrangeira (Importação direta)</option>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="form-label">
                                            <Text>
                                                CST ICMS
                                            </Text>
                                        </div>
                                        <FormControl
                                            onChange={this.handleChangeSelect}
                                            as="select"
                                            name="cst">
                                            <option selected disabled value="">
                                                Selecione o CST
                                            </option>
                                            {
                                                cst.map((x, idx) => {
                                                    return <option
                                                        selected={this.state.data.cst == x.value}
                                                        value={x.value}
                                                        key={`icms-cst-view-${idx}`}>
                                                        {x.value} - {x.label}
                                                    </option>
                                                })
                                            }
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="form-label">
                                            <Text>
                                                Alíquota
                                            </Text>
                                        </div>
                                        <CurrencyInput
                                            onChange={this.handleChange}
                                            value={this.state.data.p_icms}
                                            name="p_icms"
                                            suffix="% "
                                            className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="form-label">
                                            <Text>
                                                Alíquota Interestadual
                                            </Text>
                                        </div>
                                        <CurrencyInput
                                            onChange={this.handleChange}
                                            value={this.state.data.p_icms_inter}
                                            name="p_icms_inter"
                                            suffix="% "
                                            className="form-control" />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="d-flex justify-content-end">
                                        <Button
                                            disabled={this.state.loading}
                                            onClick={this.onSave} >
                                            Salvar ICMS
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }
            }
        </AppContext>
    }
}

function RenderInputs(props) {
    return props.items.map((item, idx) => {
        if (item.as === "select") {
            const key = `icms-input-select-${item.key}-${idx}`
            return <div className="form-group" key={key}>
                <div className="form-label">
                    {item.display}
                </div>
                <FormControl
                    name={item.key}
                    onChange={props.handleChangeSelect}
                    disabled={props.loading}
                    as="select">
                    <option selected disabled value="">
                        Selecione um item abaixo
                    </option>
                    <optgroup>
                        {
                            item.options.map((option, optIdx) => {
                                const key = `icms-input-select-${item.key}-${idx}-option-${optIdx}`
                                return <option
                                    key={key}
                                    value={option.value}>{option.label}</option>
                            })
                        }
                    </optgroup>
                </FormControl>
            </div>
        } else {
            const key = `icms-input-${item.key}-${idx}`
            return <div className="form-group my-2" key={key}>
                <div className="form-label">
                    {item.display}
                </div>
                <CurrencyInput
                    className="form-control"
                    name={item.key}
                    prefix={item.prefix}
                    disabled={props.loading}
                    onChange={props.onChange}
                    decimalSeparator="."
                    thousandSeparator=","
                    precision="2"
                    value={props.data[item.key]}
                />
            </div>
        }
    })
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/ICMS/Template/index.jsx